import RunReport from "./RunReport"


export const tableColumns = [    
    {
      name: "Staff ID",
      selector: (row) => row.assigned_agent_id,
      sortable: false,   
    },    
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,   
    },    
    {
      name: "Payroll Ref",
      selector: (row) => row.payroll_reference,
      sortable: false,   
    },    
    {
      name: "Pay Rate",
      selector: (row) => '£'+row.staff_pay_rate?.toFixed(1),
      sortable: false,
    },    
    {
      name: "Total Hours",
      selector: (row) => row.total_hours?.toFixed(2),
      sortable: false,
    },
    {
        name: "Total",
        selector: (row) => '£'+row.total?.toFixed(2),
        sortable: false,
      },
  ];

const PayRollReport = () => {    
  return (
    <>
    <RunReport ReportID={1} tableColumns={tableColumns} reportName={"PayRoll"}  />
    </>
  )
}

export default PayRollReport